// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E1uk","col":"styles_col__3FT8D","actions":"styles_actions__1Djtu","conflict":"styles_conflict__mZWIq"};